<template>
	<div>
		<div class="container-fluid">
		<div class="row">
			<div class="col-12 col-xl-10">
				<div class="row align-items-center justify-content-between">
					<div v-if="user_role != 'csm' " class="col-12 col-lg-4">
						<h4 class="mm-0 mb-4" @click="getProviders()">HHAs <router-link :to="{ name : 'admin.providers.create'}" tag="a" class="ml-2 button buttton-small small-button">
							    	<img src="../../../assets/images/icons/solid/plus_white.svg" width="14" />
									new
								</router-link></h4>
					</div><!--col-->
					<div v-if="user_role === 'csm' " class="col-12 col-lg-4">
						<h4 class="mm-0 mb-4" @click="getProviders()">HHAs 
							    	</h4>
					</div><!--col-->
				</div><!--row-->
			</div><!--col-->
		</div><!--row-->
		<div class="row">
			<div class="col-12 col-xl-12">
				<div class="row">
					<div class="col text-right">
						<button type="button" class="button mb-2" @click="swapTab">Show
							<template v-if="tab == 'hhas'">users</template>
							<template v-else>HHAs</template>
						</button>
					</div>
				</div>

				<template v-if="tab == 'hhas'">
					<div class="row mb-4" v-if="user_role != 'csm'">
						<div class="col-12 col-lg-3">
							<label>Agency</label>
							<multiselect v-model="selected_organization" :options="organizations" @select="organizationChanged" track-by="id" label="name"
								:allow-empty="true" :show-labels="false" @remove="organizationChanged"></multiselect>
						</div>
						<div class="col-12 col-lg-3">
							<label>Program</label>
							<multiselect v-model="selected_course" :options="courses" @select="courseChanged" track-by="value" label="label"
								:allow-empty="true" :show-labels="false" @remove="courseChanged"></multiselect>
						</div>
						<div class="col-12 col-lg-3">
							<label>Completion</label>
							<multiselect v-model="selected_completion" :options="available_completion" @select="completionChanged" label="label" track-by="value"
								:allow-empty="true" :show-labels="false" @remove="completionChanged"></multiselect>
						</div>
						<div class="col-12 col-lg-3">
							<label>Per page</label>
							<multiselect v-model="per_page" :options="[10, 25, 50, 100]" @select="changePerPage"
							:allow-empty="false" :show-labels="false"></multiselect>
						</div><!--col-->

						

					</div>
					<div class="row justify-content-between align-items-end mb-2">
						<div class="col-12 col-lg-5">
							<div class="input-content no-border m-0 ml-2 mb-2">
								<input v-model="search" :placeholder="'Search'"  @keyup.enter="getProviders()"/>					
							</div>
							<!-- <b-form-group class="mb-0">
						      <b-form-radio-group
						        id="radio-group-1"
						        v-model="active_filter"
						        :options="filter_options"
						        name="radio-options"
						      ></b-form-radio-group>
						    </b-form-group> -->
						</div><!--col-->
						
						<div class="trigger-hidden-content ml-1 d-inline-block">
					<span v-if="user_role != 'csm'" class="button mr-3">
						Bulk actions <i class="fa fa-caret-down" aria-hidden="true"></i>
					</span>
					<div class="hidden-content hc-right-bottom"> 
						<div>
							<ul class="list-unstyled text-left">								
								
								<li  class="pb-2 pt-2 d-flex align-items-center cursor-pointer" 
									@click="show_send_sms = true; send_sms_to_all = true">	
									<img width="18" src="../../../assets/images/icons/solid/envelope.svg">
									<small class="ml-1">Send SMS to all</small>
								</li>
							</ul>
						</div>
					</div>
				</div>
					</div><!--row-->
					<div class="row mb-2">
						<div class="col-6">
							<div class="trigger-hidden-content ml-1 d-inline-block">
							<span v-if="user_role != 'csm'" class=" button">
								Actions <i class="fa fa-caret-down" aria-hidden="true"></i>
							</span>
							<div class="hidden-content hc-left-bottom"> 
								<div>
									<ul class="list-unstyled text-left">								
										
										<li  class="pb-2 pt-2 d-flex align-items-center cursor-pointer"
											@click="show_send_sms = true; send_sms_to_all = false">												
											<img width="18" src="../../../assets/images/icons/solid/envelope.svg">
											<small class="ml-1">Send SMS</small>											
										</li>
										
									</ul>
								</div>
							</div>
						</div>
						</div>
						<div class="col-6">
							<div class="text-right">
								<button type="button" class="button" @click="applyFilters">Apply filters</button>
								<button type="button" class="button" @click="clearFilters">Clear</button>
							</div>
						</div>
					</div>
					
					<div class="table-responsive">
						<table class="table table-bordered">
							<thead>
								<tr>
									<th class="text-center">
										<div class="checkbox-container squared">
											<input id="check-select-all" type="checkbox" />
											<label for="check-select-all" @click="selectAll"></label>
										</div>
									</th>

									<th></th>
									<th>Mobile number</th>
									<th>Name</th>
									<th>Email</th>
									<th class="text-center min-width-110">Actions</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="item in providers" >
									<td class="text-center">
										<div class="checkbox-container squared">
											<input :id="'checkbox-'+item.id" type="checkbox" v-model="item.checked"/>
											<label :for="'checkbox-'+item.id" @click="toggleBulkSelection(item.id)"></label>
										</div>
									</td>

									<td class="text-center">
										<router-link tag="a" :to="{ name: 'admin.providers.detail', params : { id : item.id } }" :style="{ 'background-image' : 'url(data:image/jpeg;base64,'+item.image+')' }" class="picture-container thumb-container"></router-link>
									</td>
									<td>{{ item.country_code}} {{ item.phone }}</td>
									<td><router-link :to="{ name: user_role+'.providers.detail', params : { id : item.id }}" tag="a" class="bold">{{ item.last_name }} {{ item.first_name }} </router-link></td>
									
									<td>{{ item.email }}</td>
									<td class="text-center">
										<div class="trigger-hidden-content ml-1 d-inline-block">
											<span class=" button">
												<img width="15" src="../../../assets/images/icons/solid/ellipsis-h_white.svg">
											</span>
											<div class="hidden-content hc-right-bottom">
												<div>
													<ul class="list-unstyled text-left">
														
														
														<li class="pb-2 pt-2 d-flex align-items-center cursor-pointer">
														<router-link :to="{ name: user_role+'.providers.detail', params : { id : item.id } }" tag="a" >
															<img width="5" class="mr-1 ml-1" src="../../../assets/images/icons/solid/info.svg" />
															<span> View details</span>
														</router-link>
														</li>
														<template v-if="item.is_active">
															
															<li v-if="user_role != 'csm'" class="pb-2 pt-2 d-flex align-items-center cursor-pointer"  @click="resetPassword(item.id)">
																<img width="12" class="mr-2" src="../../../assets/images/icons/solid/redo.svg">
																<span> Reset pass (email)</span>
															</li>

														
															<li  class="pb-2 pt-2 d-flex align-items-center cursor-pointer" v-if="item.email != 'Not active' && user_role != 'csm'" @click="restorePassword(item.id, !item.can_reset_password)">
																<img width="12" class="mr-2" src="../../../assets/images/icons/solid/redo.svg">
																<span v-if="item.can_reset_password">Reset pass</span>
																<span v-else>Restore pass</span>
															</li>
														</template>
														<li v-if="user_role != 'csm'" class="pb-2 pt-2 d-flex align-items-center cursor-pointer"  @click="showModalDelete(item)">
															<img width="12" class="mr-2" src="../../../assets/images/icons/solid/trash.svg">
															<span> Delete</span>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="row justify-content-between ">
						<div class="col-12 col-lg-6">
							<span>Showing {{ from }} to {{ to }} of {{ total_rows }}</span>
						</div><!--col-->
						<div class="col-12 col-lg-6">
							<b-pagination align="right" :total-rows="total_rows" v-model="current_page"  @change="setPage" :per-page="parseInt(per_page)">
					    	</b-pagination>
						</div><!--col-->
					</div><!--row-->
				</template>
				<!-- USERS -->
				<template v-else>
					<div class="row justify-content-between align-items-end mb-2">
						<div class="col-12 col-lg-5">
							<div class="input-content no-border m-0 ml-2">
								<input v-model="tab_users.search" placeholder="Search by email" type="text" @keyup="getUsersTO()" />
							</div>
						</div><!--col-->
						<div class="col-12 col-lg-5">
							<multiselect v-model="tab_users.pagination.per_page" :options="[10, 25, 50, 100]" @select="changePerPageUser"
							:allow-empty="false" :show-labels="false"></multiselect>
						</div><!--col-->
					</div><!--row-->
					
					<div class="table-responsive">
						<table class="table table-bordered">
							<thead>
								<tr>
									<th>ID</th>
									<th>Email</th>
									<th class="text-center min-width-110">Actions</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="item in tab_users.users" >
									<td>{{ item.id }}</td>
									<td>{{ item.email }}</td>
									
									<td class="text-center">
										<div class="trigger-hidden-content ml-1 d-inline-block">
											<span class=" button">
												<img width="15" src="../../../assets/images/icons/solid/ellipsis-h_white.svg">
											</span>
											<div class="hidden-content hc-right-bottom">
												<div>
													<ul class="list-unstyled text-left">
														
														
														<li class="pb-2 pt-2 d-flex align-items-center cursor-pointer" @click="showModalAssign(item)">
														
															<img width="5" class="mr-1 ml-1" src="../../../assets/images/icons/solid/info.svg" />
															<span> Assign to HHA</span>
														
														</li>
														
														<li class="pb-2 pt-2 d-flex align-items-center cursor-pointer"  @click="showModalDeleteUser(item)">
															<img width="12" class="mr-2" src="../../../assets/images/icons/solid/trash.svg">
															<span> Delete</span>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="row justify-content-between ">
						<div class="col-12 col-lg-6">
							<span>Showing {{ tab_users.pagination.from }} to {{ tab_users.pagination.to }} of {{ tab_users.pagination.total_rows }}</span>
						</div><!--col-->
						<div class="col-12 col-lg-6">
							<b-pagination align="right" :total-rows="tab_users.pagination.total_rows" v-model="tab_users.pagination.current_page"  @change="setPageUsers" :per-page="parseInt(tab_users.pagination.per_page)">
					    	</b-pagination>
						</div><!--col-->
					</div><!--row-->
				</template>
			</div><!--col-->
			<!--
			<div class="col-12 col-lg-4">
				<admin-lhcsa-dashboard-chart-1  class="w-100" />
			</div><!--col-->
		</div><!--row-->
	</div><!--container-->
		
		<!-- modal delete HHA -->
		<b-modal v-model="show_delete" title="Delete HHa" @ok="deleteProvider" cancel-title="No" ok-title="Yes">
	    	<div v-if="provider_to_delete != null">
				<p class="mb-2">
					Are you sure you want to delete the HHA {{ provider_to_delete.first_name }} {{ provider_to_delete.last_name }}?
				</p>
			</div>
		</b-modal>

		<!-- modal delete user -->
		<b-modal v-model="tab_users.show_delete" title="Delete user" @ok="deleteUser" cancel-title="No" ok-title="Yes">
	    	<div v-if="user_to_delete != null">
				<p class="mb-2">
					Are you sure you want to delete the user {{ user_to_delete.email }}?
				</p>
			</div>
		</b-modal>

		<!-- modal assign to provider -->
		<b-modal v-model="tab_users.show_assign" title="Assign HHA" ok-title="Close" ok-only size="lg">
	    	<div v-if="tab_users.user_selected != null">
				<p class="mb-2">
					Assign HHA to <strong>{{ tab_users.user_selected.email }}</strong>

					<div class="form-group input-content">
						<label>Search HHA by mobile number</label>
						<input placeholder="Mobile number" type="text" v-model="tab_users.search_provider" class="form-control"  @keyup="searchProviderCheck">
					</div>

					<div class="form-group input-content">
						<template v-if="!tab_users.loading_results">
							<button type="button" class="button" @click="searchProviderCheck">Search</button>
						</template>
						<template v-else>
							<p>Searching...</p>
						</template>
					</div>

					<template v-if="tab_users.show_results">
						<div class="table-responsive" v-if="tab_users.providers.length >0 ">
							<table class="table table-bordered">
								<thead>
									<tr>
										<th>Mobile number</th>
										<th>Name</th>
										<th>Email</th>
										<th class="text-center min-width-110">Actions</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="item in tab_users.providers" >
										<td>{{ item.country_code}}{{ item.phone }}</td>
										<td><router-link :to="{ name: 'admin.providers.detail', params : { id : item.id } }" tag="a" class="bold" target="_blank">{{ item.last_name }} {{ item.first_name }} </router-link></td>
										
										<td>{{ item.email }}</td>
										<td class="text-center">
											<button type="button" class="button" @click="assignToProvider(item.id)">Assign</button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div v-else>
							<p>No results found</p>
						</div>
					</template>
				</p>
			</div>
		</b-modal>

		<!-- modal for sending sms -->
		<b-modal v-model="show_send_sms" title="Send SMS" @ok="sendSMS" cancel-title="No" ok-title="Yes">
	    	<p>Send message to :</p>

	    	<template v-if="!send_sms_to_all">
	    		<ul class="list-unstyled text-center">
					<li v-for="provider in providers" v-if="provider.checked">
						{{ provider.first_name }} {{ provider.last_name }}
					</li>
				</ul>
	    	</template>
	    	<template v-else>
	    		You will send the SMS to all HHAs 
	    	</template>
			

			<div class="input-content mb-2">
				<textarea rows="13" v-model="bulk_message_text"></textarea>
			</div>

			<small>
				<p class="mt-2 mb-1">You can personalize the message with: </p>
				<ul>
					<li>%FIRST_NAME%: first name of the employee</li>
					<li>%LAST_NAME%: last name of the employee</li>
				</ul>
			</small>

			<div slot="modal-footer" class="w-100 row">
				<div class="col-6">
					<button class="button gray-content large-button w-100" @click="show_send_sms = !show_send_sms">Cancel</button>
				</div><!--col-->
				<div class="col-6">
					<button class="button large-button w-100" @click="sendSMS">Send</button>
				</div><!--col-->
			</div>
		</b-modal>

	</div>
</template>



<script>
	export default {
		data : function(){
			return {
				user_role:'',
				current_page : 1,
				total_rows : 15,
				per_page  : 50,
				from : 0,
				to : 0,
				providers : [],
				fields : [
					'id',
					'email',
					'name',
					'dob',
					'Actions'
				],
				show_delete : false,
				provider_to_delete : null,
				page_loading : true,
				search : '',
				timeout : null,
				tab : 'hhas',
				filter_options : [
					{ text : 'Mobile number', value : 'phone' },
					{ text : 'Email', value : 'email' },
					{ text : 'Name', value : 'first_name' },
					{ text : 'Last name', value : 'last_name' }
				],
				selected_organization : null,
				selected_course : null,
				organizations : [],
				tab_users : {
					pagination : {
						current_page : 1,
						total_rows : 15,
						per_page : 50,
						from : 0,
						to : 0
					},

					users : [],
					fields : [
						'id',
						'email',
						'Actions'
					],
					timeout : null,
					search : '',
					show_delete : false,
					show_assign : false,
					user_selected : null,
					provider_selected : null,
					search_provider : '',
					providers : [],
					show_results : false,
					loading_results : false
				},
				user_to_delete : null,
				courses : [],
				available_completion : [
					{ value : 1, label : '0%', min : 0, max : 0 },
					{ value : 4, label : '1%-99%', min : 1, max : 99 },
					{ value : 5, label : '100%', min : 100, max : 9999},
					{ value : 6, label : 'All Non-completed', min : 0, max : 99}
				],
				selected_completion : null,
				current_select_all : false,
				show_send_sms : false,
				bulk_message_text : '',
				send_sms_to_all : false,
				timeout_input_existing_providers: null
			}
		},

		created : function(){
			this.user_role = this.$store.getters.getRole
			this.getProviders();
			this.getOrganizations();
			//this.getUsers();
		},

		mounted : function(){
			this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
				if(bvEvent.type == 'hide'){
					this.tab_users.providers = [];
					this.tab_users.search_provider = '';
				}
		    })
		},

		methods : {

			getProviders : function() {

				var params = {
					filters : {
						page : this.current_page,
						per_page : this.per_page,
						page_loading : this.page_loading,
						search : this.search,
					}
				}

				if(this.selected_organization != null){
					params.filters.organization_id = this.selected_organization.id;

					if(this.selected_course != null){
						params.filters.course_id = this.selected_course.value;
					}

					if(this.selected_completion != null){
						params.filters.course_completion_min = this.selected_completion.min;
						params.filters.course_completion_max = this.selected_completion.max;
					}
					
				}

				this.$store.dispatch('getProvidersCountV2', params).then((res) => {
					this.total_rows = res.data;
				}).catch((error) => {

				});

				this.$store.dispatch('getProvidersV2', params).then((res) => {
					this.providers = res.data.data;
					this.current_page = res.data.meta.current_page;
					this.per_page = res.data.meta.per_page;
					this.from = res.data.meta.from;
					this.to = res.data.meta.to;

				}).catch((error) => {
					console.log(error);
				})
			},

			getProvidersTO : function(){

				clearTimeout(this.timeout);

				this.timeout = setTimeout(() => {
					this.getProviders();
				}, 500);
			},

			getOrganizations : function() {
				var params = {
					filters : {
						per_page : 500
					}
				}
				
				this.$store.dispatch('getOrganizations', params).then((res) => {
					
					this.organizations = res.data.data;
				}).catch((error) => {
					console.log(error);
				});
			},

			getOrganizationCourses : function(){
				var params = {
					id : this.selected_organization.id,
					filters : {
						per_page : 500,
						to_select : true,
						page_loading : false
					}
				}

				this.courses = [];
				this.selected_course = null;

				this.$store.dispatch('getOrganizationCourses', params).then((res) => {
					this.courses = res.data.data;

				}).catch((error) => {
					console.log(error);
				});
			},

			applyFilters : function(){
				this.getProviders();
			},

			clearFilters : function () {
				this.selected_organization = null;
				this.selected_course = null;
				this.selected_completion = null;
				this.search = '';

				this.getProviders();
			},

			organizationChanged : function(organization){

				this.$nextTick(() => {
					this.getOrganizationCourses();
				});
			},

			courseChanged : function(course){

			},

			completionChanged : function(completion){

			},

			activeFilterChanged : function(value){

				this.$nextTick( () => {
					if(this.search != '')
						this.getProviders();
				});
			},
			setPage : function(page){
				this.current_page = page;

				this.getProviders();
			},
			showModalDelete : function(provider){
				this.provider_to_delete = provider;
				this.show_delete = true;
			},
			deleteProvider : function(provider){
				var params = {
					id : this.provider_to_delete.id
				}

				this.$store.dispatch('deleteProvider', params).then((res) => {
					console.log(res);
					this.show_delete = false;
					this.getProviders();
				}).catch((error) => {
					console.log(error);
				})
			},
			resetPassword : function(provider_id){
				var params = {
					id : provider_id,
					filters : {
						type : 'provider'
					}
				}

				this.$store.dispatch('sendResetPasswordEmail', params).then((res)=>{
					console.log(res);
				}).catch((error) => {
					console.log(error);
				});
			},
			restorePassword : function(provider_id, old){
				var params = {
					id : provider_id,
					filters : {
						old : old
					}
				}

				this.$store.dispatch('restorePassword', params).then((res)=>{
					console.log(res);
					this.getProviders();
				}).catch((error) => {
					console.log(error);
				});
			},
			changePerPage : function(value, id){

				this.current_page = Math.ceil(this.from/value);
					
				this.per_page = value;
				this.page_loading = false;
				this.getProviders();
			},
			search_ : function(){
				this.page_loading = false;
				this.getProviders();
			},

			swapTab : function(){
				if(this.tab == 'hhas'){
					this.tab = 'users';

					this.tab_users.search = '';

					this.getUsers();
				}else{
					this.tab = 'hhas';
					this.search = '';
					this.getProviders();
				}
			},

			selectAll : function(){
				this.current_select_all = !this.current_select_all;

				for(var i in this.providers){
					this.$set(this.providers[i], 'checked', this.current_select_all);
				}
				
			},

			toggleBulkSelection : function(provider_id){
				for(var i in this.providers){
					if(this.providers[i].id == provider_id ){
						this.$set(this.providers[i], 'checked', !this.providers[i].checked);
					}	
				}
			},

			messageToAll : function(){

			},

			sendSMS : function(){
				console.log("send!!");

				var provider_ids = [];


				var params = {
					id : this.id,
					provider_ids : this.getProvidersForBulkMessage(),
					text : this.bulk_message_text,
					filters : {
						search : this.search,
					}
				}

				if(this.send_sms_to_all)
					params.filters.all = true;

				if(this.selected_organization != null){
					params.filters.organization_id = this.selected_organization.id;

					if(this.selected_course != null){
						params.filters.course_id = this.selected_course.value;
					}

					if(this.selected_completion != null){
						params.filters.course_completion_min = this.selected_completion.min;
						params.filters.course_completion_max = this.selected_completion.max;
					}
				
				}

				console.log(params);

				this.$store.dispatch('providerBulkSMS', params).then((res) => {
					
					this.current_select_all = !this.current_select_all;
					this.show_send_sms = false;
					this.bulk_message_text = '';
					this.send_message_to_all = false;
				}).catch((error) => {
					console.log(error);
					this.send_message_to_all = false;
				});

			},

			getProvidersForBulkMessage : function(){
				var provider_ids = [];
				for(var i in this.providers){
					if(this.providers[i].checked)
						provider_ids.push(this.providers[i].id);
				}

				return provider_ids;
			},

			//tab users

			getUsers : function(){
				var params = {
					filters : {
						page : this.tab_users.pagination.current_page,
						per_page : this.tab_users.pagination.per_page,
						page_loading : this.tab_users.pagination.page_loading,
						search : this.tab_users.search
					}
				}

				this.$store.dispatch('getUsers', params).then((res) => {
					this.tab_users.users = res.data.data;
					this.tab_users.pagination.current_page = res.data.meta.current_page;
					this.tab_users.pagination.total_rows = res.data.meta.total;
					this.tab_users.pagination.per_page = res.data.meta.per_page;
					this.tab_users.pagination.total_rows = res.data.meta.total;
					this.tab_users.pagination.from = res.data.meta.from;
					this.tab_users.paginationto = res.data.meta.to;
				}).catch((error) => {
					console.log(error);
				})
			},	

			getUsersTO : function(){
				clearTimeout(this.tab_users.timeout);

				this.tab_users.timeout = setTimeout(() => {
					this.getUsers();
				}, 500);
			},
			setPageUsers : function(page){
				this.tab_users.pagination.current_page = page;

				this.getUsers();
			},

			changePerPageUser : function(value, id){

				this.tab_users.pagination.current_page = Math.ceil(this.tab_users.pagination.from/value);
					
				this.tab_users.pagination.per_page = value;
				this.page_loading = false;
				this.getUsers();
			},

			showModalDeleteUser : function(user){
				this.tab_users.show_delete = true;
				this.user_to_delete = user;
			},

			deleteUser : function(){

				var params = {
					user_id : this.user_to_delete.id
				}

				this.$store.dispatch('deleteUser', params).then((res) => {

					this.tab_users.show_delete = false;
					this.user_to_delete = null;

					this.getUsers();
				}).catch((error) => {
					console.log(error);
				});
			},

			showModalAssign : function(user){
				this.tab_users.user_selected = user;
				this.tab_users.show_assign = true;
			},

			assignToProvider : function(provider_id){

				var params = {
					user_id : this.tab_users.user_selected.id,
					provider_id : provider_id
				}

				this.$store.dispatch('assignUserToProvider', params).then((res) => {

					this.tab_users.providers = [];
					this.tab_users.show_assign = false;
					this.tab_users.search_provider = '';
					this.getUsers();
					this.getProviders();

				}).catch((error) => {
					console.log(error);
				});
			},
			searchProviderCheck: function(){
				clearTimeout(this.timeout_input_existing_providers);
				this.timeout_input_existing_providers = setTimeout( () => {
					this.searchProvider();
				}, 500)
			
			},

			searchProvider : function(){

					this.tab_users.loading_results = true;

					if(this.tab_users.search_provider != ''){

						this.tab_users.show_results = false;
						var params = {
							filters : {
								search : this.tab_users.search_provider,
								per_page : 100,
								page_loading : false,
							}
						}

						this.$store.dispatch('getProvidersV2', params).then((res) => {
							this.tab_users.providers = res.data.data;

							this.tab_users.show_results = true;
							this.tab_users.loading_results = false;

							
						}).catch((error) => {
							console.log(error);
							this.tab_users.loading_results = false;
						});
					}else{
						
						this.tab_users.providers = [];
						this.tab_users.show_results = true;
						this.tab_users.loading_results = false;
					}
			
				
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/admin/providers/AdminProviderListComponent.vue